export const checkEnvByAgend = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return 'mobile'
  } else if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}

export const checkEnvByWidth = () => {
  const width = window.innerWidth

  if (width < 1000) {
    return 'mobile'
  } else if (width < 1200) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}

export const getAspectRadio = () => {
  /**
   * Commons aspects:
   * 32:9, 21:9, 16:9, 16:10, 4:3
   * https://www.displayninja.com/what-is-aspect-ratio/
   */
  const gcd = (a, b) => {
    return (b == 0) ? a : gcd (b, a%b)
  }
  const w = screen.width
  const h = screen.height
  const r = gcd (w, h)
  let aw = w/r
  let ah = h/r

  if (aw == 7 || ah == 7) {
    aw *= 3
    ah *= 3
  } else if (aw == 5 || ah == 5) {
    aw *= 2
    ah *= 2
  }

  return `${aw}:${ah}`
}

export const handleWaLink = (link, phone = '') => {
    // is mobile.. 61994181556
    const number = phone !== '' ? `phone=${phone}` : ''
    let msg
    if (number == '') {
         msg = link ? `text=${link}` : ''
    } else {
        msg = link ? `&text=${link}` : ''
    }

    if (['mobile', 'tablet'].includes(checkEnvByAgend())) {
        return `https://api.whatsapp.com/send?${number}${msg}`
    } else {
        return `https://web.whatsapp.com/send?${number}${msg}`
    }
}

export const handleYouTubeLink = (url) => {
    return `https://www.youtube.com/embed/${url.substr(url.lastIndexOf('=') + 1)}?autoplay=0&controls=0&&showinfo=false`
}

export const getCurrentSectionInside = (el, offset=0) => {
  const curYOffset = window.pageYOffset
  const sections = el.querySelectorAll('section')

  return Array.from(sections).reverse().find(sectionEl => {
    // get the less deep section
    if (sectionEl.parentNode.closest('section')) {
      return false
    }

    const sectionYOffset = sectionEl.offsetTop
    return sectionYOffset <= curYOffset + offset
  })
}

export const rgbToHex = (rgbStr) => {
  const componentToHex = (c) => {
    const hex = Number(c).toString(16)
    return hex.length == 1 ? "0" + hex : hex
  }

  const rgb = rgbStr.replace(/[^0-9,]/g,'').split(',')

  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2])
}

export const isColorDark = (rgbStr) => {
  const rgb = rgbStr.replace(/[^0-9,]/g,'').split(',')

  const luma = 0.2126 * Number(rgb[0]) + 0.7152 * Number(rgb[1]) + 0.0722 * Number(rgb[2]); // per ITU-R BT.709

  return luma < 120
}

export const range = n => Array.from(Array(n).keys())

export const paginate = (curPage, allPages, maxSize) => {
  if (maxSize < 3) throw new Error('maxSize must be at least 3')
  if (maxSize%2 == 0) throw new Error('maxSize must be odd')

  const n = Math.floor(maxSize / 2)
  const curPageIdx = allPages.findIndex((x) => x == curPage)
  let leftEdgePage = curPageIdx - n
  let rightEdgePage = curPageIdx + n

  if (leftEdgePage < 0) {
  rightEdgePage += -leftEdgePage
  leftEdgePage = 0
  }
  if (rightEdgePage > allPages.length-1) {
  leftEdgePage -= rightEdgePage - (allPages.length-1)
  rightEdgePage = allPages.length-1
  }

  let paginated = []

  // set first page
  if (0 < leftEdgePage) {
      paginated.push({
          class: 'page first',
          page: allPages[0],
      })
  }

  for (let i = leftEdgePage; i <= rightEdgePage && i < allPages.length; i++) {
      const element = allPages[i];

      if (!element) {
          continue
      }

      paginated.push({
          page: element,
          class: (element == curPage) ? 'page current' : 'page'
      })
  }

  // set last page
  if (allPages.length-1 > rightEdgePage) {
      paginated.push({
          class: 'page last',
          page: allPages[allPages.length-1],
      })
  }

  return paginated
}
